import React from 'react';
import {
  ArrearsFlyoutContent,
  UpdateArrearsForm
} from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { FlyoutContainer } from '@cmhc-schl/hearth-ui';
import { useTranslation } from 'react-i18next';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import { useForm } from 'react-hook-form';

export const ArrearsFlyout = ({
  arrears,
  onArrearsUpdated,
  openFlyout,
  onFlyoutClose
}: {
  arrears: Arrears;
  onArrearsUpdated: (updatedArrears: Arrears) => void;
  openFlyout: boolean;
  onFlyoutClose: () => void;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  const form = useForm<UpdateArrearsForm>({
    mode: 'onChange',
    defaultValues: {
      amount: arrears.amount,
      status: arrears.status,
      institutionNumber: arrears.lenderInstitutionNumber,
      transitNumber: arrears.lenderTransitNumber,
      dueDate: arrears.dueDate
    }
  });

  const isFormDirty = () =>
    Object.keys(form.formState.dirtyFields).length !== 0 && !form.formState.isSubmitSuccessful;

  const confirmFlyoutClose = () => {
    if (isFormDirty()) {
      const shouldCloseFlyout = window.confirm(t('arrearsFlyout.closeFlyoutConfirmation.message'));
      if (!shouldCloseFlyout) {
        return;
      }
    }

    onFlyoutClose();
  };

  return (
    <FlyoutContainer
      id={'arrears-flyout'}
      open={openFlyout}
      onClose={confirmFlyoutClose}
      isHeaderRequired={true}
      headerText={t('arrearsFlyout.header')}
      content={
        <ArrearsFlyoutContent
          arrears={arrears}
          form={form}
          closeFlyout={confirmFlyoutClose}
          onArrearsUpdated={onArrearsUpdated}
        />
      }
    />
  );
};
